module.exports = __webpack_public_path__ + "img/img11.65dab0bb.png";